module.exports = __webpack_public_path__ + "static/img/punjab.ebc439c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/punjab.png
// module id = q+SS
// module chunks = 0